import { render } from "./CurrentLocation.vue?vue&type=template&id=ea74d5da"
import script from "./CurrentLocation.vue?vue&type=script&lang=js"
export * from "./CurrentLocation.vue?vue&type=script&lang=js"
script.render = render

export default script